/* eslint-disable @typescript-eslint/explicit-member-accessibility */
// @ts-nocheck
import { message as $message } from 'antd'
import * as Sentry from '@sentry/react'
import { captureException } from '@/utils/track'
import { getCoIdAndUid } from '@/utils/token'

function isDev() {
    return PROJECT_CONFIG.mode === 'dev'
}

function isTest() {
    return PROJECT_CONFIG.mode === 'test'
}

function isUat() {
    return PROJECT_CONFIG.mode === 'uat'
}

function isPre() {
    return PROJECT_CONFIG.sentryMode === 'pre'
}

// function isProd() {
//     return PROJECT_CONFIG.mode === 'prod'
// }

export function getPrintInnerAPIPrefix() {
    if (isDev() || isTest()) {
        return 'https://test-innerapi.scm121.com'
    } else if (isUat()) {
        return 'https://test-innerapi.scm121.com'
    } else if (isPre()) {
        return 'https://preinnerapi.scm121.com'
    }
    return 'https://innerapi.scm121.com'
    // return window.PROJECT_SETTING.requestPrefixTower
}

export const cacheRequestWrap = (fn, extraKey) => {
    return async (...ags) => {
        // 双奇中台没有返回coId和uid导致抛错登录不上，所以这里直接返回
        if (PROJECT_CONFIG.terminalName === 'OP') {
            return await fn(...ags)
        }

        const { coId, uid } = getCoIdAndUid()

        const coidAndUid = `${coId}_${uid}`
        let cacheKey = `REQUEST_CACHE`
        if (extraKey) {
            cacheKey += `_${extraKey}`
        } else {
            throw new Error('extraKey 必填')
        }
        // eslint-disable-next-line jst-gyl/disable-empty-catch
        try {
            const res = await fn(...ags)
            if (res.success && coId && uid) {
                const value = {
                    [coidAndUid]: res
                }
                localStorage.setItem(cacheKey, JSON.stringify(value))
                return res
            } else {
                captureException(extraKey + '请求错误', {
                    anchor: 'cacheRequestWrap',
                    mustNotify: false
                })
                throw new Error(extraKey + '请求错误')
            }
        } catch (error) {
            if (coId && uid && error?.code !== PROJECT_CONFIG.ERROR_NO_LOGIN_CODE) {
                const res = localStorage.getItem(cacheKey) || '{}'
                const temp = JSON.parse(res)
                return temp[coidAndUid] || {}
            }
            return {}
        }
    }
}

const REQUEST_TYPE_GET = 'get'
const REQUEST_TYPE_POST = 'post'
const TIMT_OUT = 100

// @ts-nocheck
export class RequestCache {
    lastRequest_cache_map = {}
    data_cache = {}
    serviceType = null
    timerId = null
    timeout = TIMT_OUT

    constructor(serviceType) {
        this.serviceType = serviceType
    }

    checkExprie() {
        const doTask = () => {
            const fn = () => {
                this.timerId && clearTimeout(this.timerId)
                const now = Date.now()
                if (!this.data_cache)
                    for (let key of this.data_cache) {
                        const target = this.data_cache[key]

                        const { timestamp } = target
                        if (now - timestamp > this.timeout) {
                            delete this.data_cache[key]
                        }
                    }
                if (this.data_cache.size) {
                    this.timerId = setTimeout(fn, this.timeout)
                }
            }

            this.timerId = setTimeout(fn, this.timeout)
        }
        doTask()
    }

    get(url, params) {
        return this.requestCache({ url, params, type: REQUEST_TYPE_GET })
    }

    post(url, params) {
        return this.requestCache({ url, params, type: REQUEST_TYPE_POST })
    }

    requestCache({ url, params, type, timer = 100 }) {
        const cacheKey = url + JSON.stringify(params)
        const now = Date.now()
        if (this.data_cache[cacheKey] && now - this.data_cache[cacheKey].timestamp < timer) {
            if (!this.timerId) {
                this.checkExprie()
            }
            return Promise.resolve(this.data_cache[cacheKey].data)
        } else if (this.lastRequest_cache_map[cacheKey]) {
            return this.lastRequest_cache_map[cacheKey].then(response => {
                this.data_cache[cacheKey] = { data: response, timestamp: Date.now() } // 缓存请求数据，并记录获取时间
                return response
            })
        } else {
            // eslint-disable-next-line no-async-promise-executor
            this.lastRequest_cache_map[cacheKey] = new Promise(async resolve => {
                let response = null

                if (type === REQUEST_TYPE_GET) {
                    response = await this.serviceType.get(url, params)
                }
                if (type === REQUEST_TYPE_POST) {
                    response = await this.serviceType.post(url, params)
                }

                this.data_cache[cacheKey] = { data: response, timestamp: Date.now() } // 缓存请求数据，并记录获取时间
                this.lastRequest_cache_map[cacheKey] = null
                resolve(response)
            })
            return this.lastRequest_cache_map[cacheKey].then(response => {
                return response
            })
        }
    }
}

const getSeiviceMap = new Map()
export const getCacheService = serviceType => {
    if (!getSeiviceMap.has(serviceType)) {
        getSeiviceMap.set(serviceType, new RequestCache(serviceType))
    }
    return getSeiviceMap.get(serviceType)
}

// post 接口原则上不缓存，但是有一些接口post接口当成get使用
const postSeiviceMap = new Map()
export const postCacheService = serviceType => {
    if (!postSeiviceMap.has(serviceType)) {
        postSeiviceMap.set(serviceType, new RequestCache(serviceType))
    }
    return postSeiviceMap.get(serviceType)
}

/** 接口通用处理：接口级异常，在这一层统一处理；业务可只关心成功的情况；后续考虑封装到拦截器里 */ function handleError(
    err: unknown
) {
    console.error(err)
    Sentry.setExtra('extra', err)
    Sentry.captureException(new Error('接口请求异常'))
    $message.error('接口请求异常')
}

export async function requestSync<T>(requestHandler: () => Promise<T>): Promise<T> {
    let res: T | undefined
    try {
        res = await requestHandler()
        const { success, message } = res || {}
        if (!success) {
            $message.error(message ?? '接口请求异常')
        }
    } catch (err) {
        console.error(err)
        handleError(err)
        res = {} as T // 明确返回一个空对象
    }
    return res || ({} as T)
}
